import React, { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { useEditSubjectMutation } from "../../../features/api/subjectApi";

const UpdateSubject = ({ category }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };
  const [editSubject] = useEditSubjectMutation();

  const [title, setSubjectTitle] = useState("");
  const handleUpdate = async (id) => {
    try {
      const editData = {
        id: id,
        title: title,
      };
      const response = await editSubject(editData);

      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Update Success...!!!");
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };

  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md md:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <label className="font-bold">Subject Title:</label>
                  <input
                    type="text"
                    defaultValue={category?.title}
                    onChange={(e) => setSubjectTitle(e.target.value)}
                    className="border pl-1 w-full"
                  />
                  <button
                    onClick={() => handleUpdate(category?.id)}
                    className="bg-green-500 text-white font-bold mt-4 px-4 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSubject;
